







































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
@Component
export default class Params extends Vue {
    @Prop(Array)
    private tokens?: any[]

    @Prop({ default: true })
    private stoped?: boolean

    private address: string = ''
    private tokenAddress: string[] = []

    private disabled = false

    get accounts() {
        return this.address.trim().split(',').map(item => {
            return item.trim().toLowerCase()
        })
    }

    @Watch('stoped')
    public onStopChange() {
        this.disabled = !this.stoped
    }
    public stop() {
        this.$emit('stop')
    }

    public checkCondation() {
        this.$emit('check', { tokens: this.tokenAddress, accounts: this.accounts })
        this.disabled = true
    }
}
